const commentsConstants = {
	GET_AUTONOTE_FULFILLED: 'GET_AUTONOTE_FULFILLED',
	GET_AUTONOTE_ERROR: 'GET_AUTONOTE_ERROR',
	SB_AUTONOTE: 'SB_AUTONOTE',
};

export default commentsConstants;
